/** @format */
import { post, download } from '@root/utils/httpWrap';

// 车场流量（车场视图）
export const infoParkFlowList = (params: any): any => {
  return post('bangdao/saasapi/v1/flow/infoParkFlowList', params);
};

// 车场流量导出（车场视图）
export const infoExport = (params: any): any => {
  return download('bangdao/saasapi/v1/flow/infoExport', params);
};

// 车场流量（机构视图）
export const infoParkFlowOrgList = (params: any): any => {
  return post('bangdao/saasapi/v1/flow/infoParkFlowOrgList', params);
};

// 车场流量导出（机构视图）
export const infoOrgExport = (params: any): any => {
  return download('bangdao/saasapi/v1/flow/infoOrgExport', params);
};
// 通道列表
export const infoParkChannelList = (params: any): any => {
  return post('bangdao/saasapi/v1/flow/infoParkChannelList', params);
};

// 临停收入分析
export const reportTemporaryAnalysisList = (params: any): any => {
  return post('bangdao/saasapi/v1/reportTemporaryAnalysis/reportList', params);
};
// 临停收入分析导出
export const reportTemporaryAnalysisExport = (params: any): any => {
  return download('bangdao/saasapi/v1/reportTemporaryAnalysis/exportExcel', params);
};
// 固定收入分析
export const fixedParkPaymentList = (params: any): any => {
  return post('bangdao/saasapi/v1/fixedParkPayment/reportFormList', params);
};
// 固定收入分析图表
export const fixedParkPaymentChart = (params: any): any => {
  return post('bangdao/saasapi/v1/fixedParkPayment/reportList', params);
};
// 固定收入分析导出
export const fixedParkPaymentExport = (params: any): any => {
  return download('bangdao/saasapi/v1/fixedParkPayment/parkReportFormExport', params);
};
// 支付方式分析
export const payMethodList = (params: any): any => {
  return post('bangdao/saasapi/v1/payMethod/dayReportList', params);
};
// 支付方式导出
export const payMethodExport = (params: any): any => {
  return download('bangdao/saasapi/v1/payMethod/dayReportExport', params);
};
// 停车时长分布
export const getParktimeDistribution = (params: any): any => {
  return post('bangdao/saasapi/v1/parktime/distribution', params);
};
// 停车时长TOP车场
export const getParktimeTop = (params: any): any => {
  return post('bangdao/saasapi/v1/parktime/top', params);
};
// 平均停车时长
export const getParktimeAverage = (params: any): any => {
  return post('bangdao/saasapi/v1/parktime/average', params);
};
// 异常操作分析-概览
export const abnormalOverview = (params: any): any => {
  return post('bangdao/saasapi/v1/abnormalAnalysis/overview', params);
};
// 异常操作分析-排名
export const abnormalParkRanking = (params: any): any => {
  return post('bangdao/saasapi/v1/abnormalAnalysis/parkRanking', params);
};
// 异常操作分析-表格
export const abnormalDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/abnormalAnalysis/detail', params);
};
//异常操作分析-图表
export const abnormalTrend = (params: any): any => {
  return post('/bangdao/saasapi/v1/abnormalAnalysis/trend', params);
};
// 车位周转率-折线图
export const turnoverInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/turnover/info', params);
};
// 车位周转率-排名列表
export const turnoverRank = (params: any): any => {
  return post('/bangdao/saasapi/v1/turnover/rank', params);
};
// 车位周转率-详情列表
export const turnoverDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/turnover/detail', params);
};
// 车位利用率-折线图
export const utilizationInfo = (params: any): any => {
  return post('/bangdao/saasapi/v1/utilization/info', params);
};
// 车位利用率-排名列表
export const utilizationRank = (params: any): any => {
  return post('/bangdao/saasapi/v1/utilization/rank', params);
};
// 车位利用率-详情列表
export const utilizationDetail = (params: any): any => {
  return post('/bangdao/saasapi/v1/utilization/detail', params);
};
